import React from 'react';
import {
  WhiteInstantSearchBuilder,
  AutocompleteHeader,
  AutocompleteHighlight,
  AutocompleteItem,
  AutocompleteProductItem,
} from '@white-nl/instantsearch-components';

declare global {
  interface Window {
    whiteInstantSearchSearchBar?: WhiteInstantSearchBuilder;
  }
}

export default function initWhiteInstantSearchSearchBar() {
  const searchBarSelector = '#white-instant-search-search-box-global';
  const searchBar = document.querySelector(searchBarSelector) as HTMLElement;

  if (searchBar) {
    const whiteInstantSearchSearchBar = new WhiteInstantSearchBuilder();
    const { searchUrl, categoriesIndexName, currentSite } = (searchBar as HTMLDivElement).dataset;

    whiteInstantSearchSearchBar
      .addAutocompleteSearchingComponent([
        {
          settings: {
            placeholder: Craft.t('catalog', 'What are you looking for?'),
            useRecentSearches: true,
            sources: [
              {
                indexName: categoriesIndexName,
                getQueryParams: (query, defaultFilters?) => ({
                  query,
                  filters: `siteId:${currentSite} ${(defaultFilters ? `AND (${defaultFilters})` : '')}`,
                  hitsPerPage: 3,
                }),
                transformResponse: ({ hits }: { hits: any[] }) => (
                  hits[0].map((hit: any) => ({
                    ...hit,
                    url: `${hit.url}`,
                    breadcrumbs: hit.breadcrumbs ? `in ${hit.breadcrumbs}` : null,
                  }))
                ),
                templates: {
                  header: () => (<AutocompleteHeader title={Craft.t('catalog', 'Categories')} />),
                  item: ({
                    item,
                    source,
                    components,
                    state,
                  }) => (
                    <AutocompleteItem
                      hit={item}
                      url={source.getItemUrl!({ item, state })!}
                      components={{ ...components, Highlight: AutocompleteHighlight }}
                      titleAttribute="title"
                      descriptionAttribute="breadcrumbs"
                      onFillQuery={() => source.onFillQuery({ item, state })}
                    />
                  ),
                },
              },
              {
                getQueryParams: (query, defaultFilters?) => ({
                  query,
                  filters: `siteId:${currentSite} ${(defaultFilters ? `AND (${defaultFilters})` : '')}`,
                  hitsPerPage: 4,
                }),
                transformResponse: ({ hits }: { hits: any[] }) => (
                  hits[0].map((hit: any) => ({
                    ...hit,
                    url: `${hit.url}`,
                  }))
                ),
                templates: {
                  header: () => (<AutocompleteHeader title={Craft.t('catalog', 'Products')} />),
                  item: ({
                    item,
                    source,
                    components,
                    state,
                  }) => (
                    <AutocompleteProductItem
                      hit={item}
                      url={source.getItemUrl!({ item, state })!}
                      components={{ ...components, Highlight: AutocompleteHighlight }}
                      titleAttribute="title"
                      descriptionAttribute="productCode"
                      imageAttribute={['productImages', '0', 'transforms', 'productCatalogThumb', 'url']}
                      priceAttribute="defaultPrice"
                      salePriceAttribute="defaultPrice"
                      imagePlaceholder={(
                        <div className="aa-ItemIcon aa-ItemIcon--picture aa-ItemIcon--alignTop">
                          <img src="/img/placeholder.png" alt={item.title} />
                        </div>
                      )}
                      onFillQuery={() => source.onFillQuery({ item, state })}
                    />
                  ),
                  footer: ({
                    items,
                    state,
                  }) => (
                    <div>
                      {items.length >= 4 && (
                        <div className="autocomplete-all-results-link pb-2">
                          <a href={`${searchUrl}?query=${state.query}`} className="decoration-transparent decoration-2 underline-offset-3 font-semibold hover:decoration-pink-400 hover:decoration-pink-400 font-light ">
                            {Craft.t('catalog', 'All results')}
                          </a>
                        </div>
                      )}
                    </div>
                  ),
                },
              },
            ],
            onSubmit: (query: string) => {
              window.location.href = `${searchUrl}?query=${query}`;
            },
          },
        },
      ], searchBarSelector);

    window.whiteInstantSearchSearchBar = whiteInstantSearchSearchBar;
  }
}
